import { useApolloClient } from "@apollo/client";
import { useAsyncExecutor2 } from "async-executor-hook";
import { addDays, format } from "date-fns";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import { getDateAttribute } from "../../common/searchParams.utils";
import { AdminComplaintsSearch } from "../AdminComplaintsSearch/AdminComplaintsSearch";
import { AdminComplaintsTable } from "../AdminComplaintsTable/AdminComplaintsTable";
import { Container } from "./AdminComplaintsStyles";
import requestData from "./requestData";

export const AdminComplaintsResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: any) => {
      const enterDate = getDateAttribute(
        params.enterDate,
        addDays(new Date(), -60)
      );
      return { ...params, enterDate };
    })
  );

  const client = useApolloClient();

  const loadComplains = useAsyncExecutor2(
    (params) => {
      const {
        page,
        caseNumber,
        status,
        enterDate,
        area,
        clientName,
        category,
      } = params;

      const networkOnly = true;
      return requestData(
        client,
        page,
        caseNumber,
        status,
        enterDate,
        area,
        clientName,
        category,
        networkOnly
      ).then((resp) => {
        return resp.getAllDemand;
      });
    },

    {
      params$: params$.pipe(
        map((params) => {
          return {
            ...params,
            enterDate: format(params.enterDate, "yyyy-MM-dd"),
            page: params.page ? parseInt(params.page) : 1,
          };
        })
      ),
    }
  );

  return (
    <Container>
      <AdminComplaintsSearch params$={params$} />
      <AdminComplaintsTable loadComplains={loadComplains} />
    </Container>
  );
};
